import { render, staticRenderFns } from "./ProductRelatedProducts.vue?vue&type=template&id=0f2e8fab&scoped=true&"
import script from "./ProductRelatedProducts.vue?vue&type=script&lang=ts&"
export * from "./ProductRelatedProducts.vue?vue&type=script&lang=ts&"
import style0 from "./ProductRelatedProducts.vue?vue&type=style&index=0&id=0f2e8fab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2e8fab",
  null
  
)

export default component.exports